import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { ReactComponent as Logo } from 'shared/img/logo.svg'

import { projectStyledName } from 'shared/constants'

import { selectLocaleDict } from 'features/locale/selectors'

import { FOOTER_PROVIDER_ICONS } from './data/providerIcons'
import { ReactComponent as YearIcon } from './img/years.svg'

import './Footer.scss'

interface IFooterProps {
  scrollRef: React.RefObject<HTMLDivElement> | null
}

const b = block('footer')

export const Footer: React.FC<IFooterProps> = ({ scrollRef }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).common

  return (
    <div className={b()}>
      <div className={b('wrapper')}>
        <div className={b('logo-wrapper')}>
          <Logo className={b('logo')} />
          <YearIcon className={b('years')} />
        </div>

        <div className={b('providers')}>
          {FOOTER_PROVIDER_ICONS.map(({ id, Icon }) => (
            <Icon key={id} className={b('provider')} />
          ))}
        </div>

        <div className={b('bottom')}>
          <div className={b('copyright')}>
            © {projectStyledName}. {locale.footerRights}.
          </div>
        </div>
      </div>
    </div>
  )
}
